import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';

export interface User {
  id: string;
  email: string;
  nombre?: string;
  rol: 'cliente' | 'admin' | 'proveedor';
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  
  private readonly http = inject(HttpClient);

  readonly currentUser = signal<User | null>(null);

  me(): Observable<User | null> {
    return this.http
      .get<User>(`${environment.apiUrl}/auth/me`, { withCredentials: true })
      .pipe(
        tap(user => this.currentUser.set(user)),
        catchError(() => {
          this.currentUser.set(null);
          return of(null);
        }),
      );
  }

  logout(): void {
    this.http
      .post<void>(`${environment.apiUrl}/auth/logout`, {}, { withCredentials: true })
      .subscribe({
        next: () => this.redirectToLogin(),
        error: () => this.redirectToLogin(),
      });
  }

  private redirectToLogin(): void {
    // Limpia el estado del usuario en cliente antes de salir
    // Usamos replace() (no href) para que la URL del dashboard se elimine del historial 
    this.currentUser.set(null);
    window.location.replace(environment.uniloginUrl);
  }

}
